import '../../index.css';
var styles = {
  "text": "bp_text_with_info_badge_module_text--7e18e",
  "muted": "bp_text_with_info_badge_module_muted--7e18e",
  "badgeContainer": "bp_text_with_info_badge_module_badgeContainer--7e18e",
  "badge": "bp_text_with_info_badge_module_badge--7e18e"
};
export { styles as default };